<template>
  <div class="flex flex-wrap gap-2">
    <div
      v-for="icon in iconClasses"
      :key="icon"
      class="flex flex-col w-[126px] h-[126px] border border-solid border-racq-white justify-center items-center text-center"
    >
      <div :class="['icon', icon]" class="w-[100%] h-[100%] !bg-no-repeat !bg-center mb-1"></div>
      <p class="text-[10px]">{{ icon }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
const iconClasses = [
  'bg-login-icon',
  'bg-calendar-icon',
  'bg-step-completed-icon',
  'bg-datepicker-calendar-icon',
  'bg-datepicker-prev-icon',
  'bg-datepicker-next-icon',
  'bg-warnning-icon',
  'bg-tag-icon',
  'bg-document-icon',
  'bg-pet-icon',
  'bg-payment-filled-icon',
  'bg-house-icon',
  'bg-home-icon',
  'bg-content-icon',
  'bg-user-icon',
  'bg-phone-icon',
  'bg-car-icon',
  'bg-car-filled-icon',
  'bg-shopping-bag-icon',
  'bg-battery-icon',
  'bg-movie-ticket-icon',
  'bg-icon-success',
  'bg-icon-warning',
  'bg-icon-danger',
  'bg-icon-info',
  'bg-icon-bank-account',
  'bg-icon-active',
  'bg-icon-cancelled',
  'bg-icon-mastercard',
  'bg-icon-check',
  'bg-icon-star',
  'bg-icon-chevron-down',
  'bg-icon-arrow-down',
  'bg-icon-chevron',
  'bg-icon-small-nextTick',
  'bg-icon-small-cross',
  'bg-date-icon',
  'bg-dollar-filled-icon',
  'bg-dollar-filled-circle-icon',
];
</script>
